import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import loginPageStyle from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle';
// apollo //
import { apiClient } from 'client';
import { ApolloProvider } from 'react-apollo';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import UserLogin from 'components/User/Login';

const ScreenUserLogin = props => {
  const { classes } = props;
  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={4}>
          <ApolloProvider client={apiClient}>
            <UserLogin {...props} />
          </ApolloProvider>
        </GridItem>
      </GridContainer>
    </div>
  );
};

ScreenUserLogin.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(loginPageStyle)(ScreenUserLogin);
